import { t } from '@lingui/macro';

import type { Icon } from '@rover/icons';
import Time from '@rover/icons/svg/time.svg';
import type { ThemeTextColor } from '@rover/kibble/styles/themeTypes';
import { EngagementSignal } from '@rover/rsdk/src/apiClient/latest/model/engagementSignal';

type EngagementSignalId = 'highly_responsive';

type EngagementSignalContent = {
  fullText: string;
  icon: Icon;
  color: ThemeTextColor;
};

const ENGAGEMENT_SIGNAL_CONTENT_ENUM = (): Record<EngagementSignalId, EngagementSignalContent> => ({
  highly_responsive: {
    fullText: t`<0>Highly</0> responsive`,
    icon: Time,
    color: 'success',
  },
});

export const getEngagementSignalContent = (
  engagementSignal: EngagementSignal | null | undefined
): EngagementSignalContent | undefined => {
  if (!engagementSignal?.id) {
    return undefined;
  }

  return ENGAGEMENT_SIGNAL_CONTENT_ENUM()[engagementSignal.id];
};
